/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';

/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
import { useBlockProps } from '@wordpress/block-editor';

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './editor.scss';

/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @return {WPElement} Element to render.
 */

import { Fragment, useState } from '@wordpress/element';
import { InspectorControls, BlockControls } from '@wordpress/block-editor';
import { PanelBody, QueryControls, FormTokenField, SelectControl, ToggleControl, TextControl } from '@wordpress/components';
import { useSelect } from '@wordpress/data';
import ServerSideRender from '@wordpress/server-side-render';
import Slider from "react-slick";
import { useEffect } from 'react';


export default function Edit(props) {

	const termsQuery = { post_type: 'itineraries', per_page: 100 };

	const tripTypes = useSelect((select) => {
		return select('core').getEntityRecords('taxonomy', 'itinerary_types', termsQuery);
	}, []);

	const tripDestinations = useSelect((select) => {
		return select('core').getEntityRecords('taxonomy', 'travel_locations', termsQuery);
	}, []);

	const tripActivities = useSelect((select) => {
		return select('core').getEntityRecords('taxonomy', 'activity', termsQuery);
	}, []);

	const tripKeywords = useSelect((select) => {
		return select('core').getEntityRecords('taxonomy', 'travel_keywords', termsQuery);
	}, []);

	const { setAttributes, attributes } = props;
	const { relatedTrip, patternSlug, loadMore, loadMoreLabel, inheritTrips, query, saleTrip, featuredTrip, layoutType, cardLayout, relatedTripBy } = attributes;

	const {
		orderBy,
		order,
		selectedCategories,
		selectedTripTypes,
		selectedTripDestinations,
		selectedTripActivities,
		selectedTripKeywords,
		numberOfItems,
	} = query;

	const TripTypeSuggestions = tripTypes?.reduce(
		(accumulator, category) => ({
			...accumulator,
			[category.name]: category,
		}),
		{}
	) ?? {};

	let selected_trip_types = [];
	if (selectedTripTypes && selectedTripTypes.length > 0) {
		selected_trip_types = selectedTripTypes.map((type) => {
			return type.name;
		})
	}

	const TripDestinationSuggestions = tripDestinations?.reduce(
		(accumulator, category) => ({
			...accumulator,
			[category.name]: category,
		}),
		{}
	) ?? {};
	let selected_trip_destinations = [];
	if (selectedTripDestinations && selectedTripDestinations.length > 0) {
		selected_trip_destinations = selectedTripDestinations.map((type) => {
			return type.name;
		})
	}

	const TripActivitySuggestions = tripActivities?.reduce(
		(accumulator, category) => ({
			...accumulator,
			[category.name]: category,
		}),
		{}
	) ?? {};
	let selected_trip_activities = [];
	if (selectedTripActivities && selectedTripActivities.length > 0) {
		selected_trip_activities = selectedTripActivities.map((type) => {
			return type.name;
		})
	}

	const TripKeywordSuggestions = tripKeywords?.reduce(
		(accumulator, category) => ({
			...accumulator,
			[category.name]: category,
		}),
		{}
	) ?? {};
	let selected_trip_keywords = [];
	if (selectedTripKeywords && selectedTripKeywords.length > 0) {
		selected_trip_keywords = selectedTripKeywords.map((type) => {
			return type.name;
		})
	}

	// const [sliderWidth, setSliderWidth] = useState(0);
	// useEffect(() => {
    //     try {
    //         const sliderWPtravel = document.getElementsByClassName("wp-block-wptravel-trips-list")[0];
    //         if (!sliderWPtravel) return;

    //         const resizeObserver = new ResizeObserver(entries => {
    //             for (let entry of entries) {
    //                 if (entry.target === sliderWPtravel) {
    //                     setSliderWidth(entry.contentRect.width);
    //                 }
    //             }
    //         });

    //         resizeObserver.observe(sliderWPtravel);

    //         return () => {
    //             resizeObserver.disconnect();
    //         };
    //     } catch (error) {
    //         console.error('Error occurred in Trip List Slider:', error);
    //     }
    // }, []);

	const slidesToShow =  (typeof attributes.align == 'undefined' ) ? 2 : 3;

	const settings = {
		dots: false,
		arrows: true,
		autoplay: true,
		infinite: true,
		speed: 500,
		slidesToShow: slidesToShow,
		slidesToScroll: 1
	};

	const [tripList, setTripLists] = useState([]);

	useSelect(() => {
		fetch(_wp_travel.site_url + '/wp-json/wp-travel-block/v1/get-trip-lists?arg=' + JSON.stringify(attributes), {
			method: "GET"
		}).then((res) => res.json())
			.then((data) => setTripLists(data))
			.catch((err) => console.error(err));
	}, []);

	return (
		<div {...useBlockProps()}>
			<Fragment>
				<InspectorControls>

					<PanelBody title={__('Filters', 'wp-travel-blocks')}>
						<ToggleControl
							label={__('Inherit Trips', 'wp-travel-blocks')}
							checked={inheritTrips}
							onChange={() => setAttributes({ inheritTrips: !inheritTrips })}
						/>

						<ToggleControl
							label={__('Show Related Trip', 'wp-travel-blocks')}
							checked={relatedTrip}
							onChange={() => setAttributes({ relatedTrip: !relatedTrip })}
						/>
						<ToggleControl
							label={__('Sale Trip', 'wp-travel-blocks')}
							checked={saleTrip}
							onChange={() => setAttributes({ saleTrip: !saleTrip })}
						/>
						<ToggleControl
							label={__('Featured Trip', 'wp-travel-blocks')}
							checked={featuredTrip}
							onChange={() => setAttributes({ featuredTrip: !featuredTrip })}
						/>
						{
							relatedTrip && 
							<SelectControl
								label={__('Related Trip By', 'wp-travel-blocks')}
								value={relatedTripBy}
								options={[
									{
										label: __('Itinerary Types', 'wp-travel-blocks'),
										value: 'itinerary-types'
									}, {
										label: __('Travel Location', 'wp-travel-blocks'),
										value: 'travel-locations'
									}, {
										label: __('Travel Keywords', 'wp-travel-blocks'),
										value: 'travel-keywords'
									}, {
										label: __('Travel Activity', 'wp-travel-blocks'),
										value: 'activity'
									}
								]}
								onChange={(val) => setAttributes({ relatedTripBy: val })}
							/>
						}
						
						<SelectControl
							label={__('Select Layout', 'wp-travel-blocks')}
							value={layoutType}
							options={cardLayout !== 'slider-view' && [
								{
									label: __('Default Layout', 'wp-travel-blocks'),
									value: 'default-layout'
								},
								{
									label: __('Layout One', 'wp-travel-blocks'),
									value: 'layout-one'
								}, {
									label: __('Layout Two', 'wp-travel-blocks'),
									value: 'layout-two'
								}, {
									label: __('Layout Three', 'wp-travel-blocks'),
									value: 'layout-three'
								}, {
									label: __('Layout Four', 'wp-travel-blocks'),
									value: 'layout-four'
								}, {
									label: __('Custom Layout', 'wp-travel-blocks'),
									value: 'custom'
								}
							] || [
									{
										label: __('Layout One', 'wp-travel-blocks'),
										value: 'layout-one'
									}, {
										label: __('Layout Two', 'wp-travel-blocks'),
										value: 'layout-two'
									}, {
										label: __('Layout Three', 'wp-travel-blocks'),
										value: 'layout-three'
									}, {
										label: __('Layout Four', 'wp-travel-blocks'),
										value: 'layout-four'
									}
								]}
							onChange={(val) => setAttributes({ layoutType: val })}
						/>
						{
							layoutType == 'custom' &&
							<TextControl
								label="Pattern Slug"
								value={patternSlug}
								onChange={ value => setAttributes(
									{
										patternSlug: value
									}
								) }
							/>
							
						}
						{layoutType != 'default-layout' && layoutType != 'custom' &&
							<SelectControl
								label={__('Card Layout', 'wp-travel-blocks')}
								value={cardLayout}
								options={[
									{
										label: __('Slider', 'wp-travel-blocks'),
										value: 'slider-view'
									}, {
										label: __('Grid', 'wp-travel-blocks'),
										value: 'grid-view'
									}, {
										label: __('List', 'wp-travel-blocks'),
										value: 'list-view'
									}
								]}
								onChange={(val) => setAttributes({ cardLayout: val })}
							/>
						}
						{
							( !inheritTrips && !relatedTrip && !saleTrip && !featuredTrip && cardLayout != 'slider-view' ) &&
							<>
								<ToggleControl
									label={__('Enable Load More', 'wp-travel-blocks')}
									checked={loadMore}
									onChange={() => setAttributes({ loadMore: !loadMore })}
								/>
								{
									loadMore &&
									<TextControl
									label="Load More Button Label"
										value={loadMoreLabel}
										onChange={ value => setAttributes(
											{
												loadMoreLabel: value
											}
										) }
									/>
								}
								
							</>
						}
						{
							(!inheritTrips && !relatedTrip) &&
							<>
								<QueryControls
									{...{ orderBy, order, numberOfItems }}
									onNumberOfItemsChange={(newNumberOfItems) =>
										setAttributes({
											query: {
												...query,
												numberOfItems: newNumberOfItems,
											},
										})
									}
								/>
								<SelectControl
									label={__('Order by', 'wp-travel-blocks')}
									value={orderBy + '/' + order}
									options={[
										{
											label: __('Newest to oldest', 'wp-travel-blocks'),
											value: 'date/desc'
										}, {
											label: __('Oldest to newest', 'wp-travel-blocks'),
											value: 'date/asc'
										}, {
											label: __('A → Z', 'wp-travel-blocks'),
											value: 'title/asc'
										}, {
											label: __('Z → A', 'wp-travel-blocks'),
											value: 'title/desc'
										}
									]}
									onChange={(selectedVal) => {
										let values = selectedVal.split('/');
										let newOrderBy = values[0];
										let newOrder = values[1];
										setAttributes({
											query: {
												...query,
												orderBy: newOrderBy,
												order: newOrder,
											},
										});
									}}
								/>
								<FormTokenField
									label={__('Trip Type')}
									value={selected_trip_types ?? []}
									suggestions={Object.keys(TripTypeSuggestions).map(name => { return name })}
									onChange={tokens => {
										const allCategories = tokens.map((token) => {
											const newData = typeof token === 'string' ? TripTypeSuggestions[token] : token;
											const selected = {
												count: newData.count,
												id: newData.id,
												description: newData.description,
												link: newData.link,
												taxonomy: newData.taxonomy,
												name: newData.name,
												slug: newData.slug,
											}
											return selected;
										});
										setAttributes({
											query: {
												...query,
												selectedTripTypes: allCategories,
											},
										});
									}}
								/>
								<FormTokenField
									label={__('Trip Destinations')}
									value={selected_trip_destinations ?? []}
									suggestions={Object.keys(TripDestinationSuggestions).map(name => { return name })}
									onChange={tokens => {
										const allCategories = tokens.map((token) => {
											const newData = typeof token === 'string' ? TripDestinationSuggestions[token] : token;
											const selected = {
												count: newData.count,
												id: newData.id,
												description: newData.description,
												link: newData.link,
												taxonomy: newData.taxonomy,
												name: newData.name,
												slug: newData.slug,
											}
											return selected;
										});
										setAttributes({
											query: {
												...query,
												selectedTripDestinations: allCategories,
											},
										});
									}}
								/>

								<FormTokenField
									label={__('Trip Activities', 'wp-travel-blocks')}
									value={selected_trip_activities ?? []}
									suggestions={Object.keys(TripActivitySuggestions).map(name => { return name })}
									onChange={tokens => {
										const allCategories = tokens.map((token) => {
											const newData = typeof token === 'string' ? TripActivitySuggestions[token] : token;
											const selected = {
												count: newData.count,
												id: newData.id,
												description: newData.description,
												link: newData.link,
												taxonomy: newData.taxonomy,
												name: newData.name,
												slug: newData.slug,
											}
											return selected;
										});
										setAttributes({
											query: {
												...query,
												selectedTripActivities: allCategories,
											},
										});
									}}
								/>
								<FormTokenField
									label={__('Trip Keywords', 'wp-travel-blocks')}
									value={selected_trip_keywords ?? []}
									suggestions={Object.keys(TripKeywordSuggestions).map(name => { return name })}
									onChange={tokens => {
										const allCategories = tokens.map((token) => {
											const newData = typeof token === 'string' ? TripKeywordSuggestions[token] : token;
											const selected = {
												count: newData.count,
												id: newData.id,
												description: newData.description,
												link: newData.link,
												taxonomy: newData.taxonomy,
												name: newData.name,
												slug: newData.slug,
											}
											return selected;
										});
										setAttributes({
											query: {
												...query,
												selectedTripKeywords: allCategories,
											},
										});
									}}
								/>
								
							</>
						}
					</PanelBody>
				</InspectorControls>
			</Fragment>
			{
				cardLayout === 'slider-view' &&
				<div id="wptravel-block-trips-list"
					className={'wptravel-block-wrapper wptravel-block-trips-list wptravel-block-preview ' + layoutType}
				>
					<div className="wp-travel-itinerary-items">
						<Slider
							className='wp-travel-itinerary-items wptravel-archive-wrapper slider-view grid-view'
							{...settings}
						>
							{
								tripList.map((data) => {
									return (
										<>
											{
												layoutType === 'default-layout' &&
												<div className="wptravel-blocks-trip-card">
													<div className="wptravel-blocks-trip-card-img-container">
														<img fetchpriority="high" width="1024" height="684" src={data.featured_img} sizes="(max-width: 1024px) 100vw, 1024px"></img>
														<div className="wptravel-blocks-img-overlay">
															{data.is_featured_trip == 'yes' &&
																<div class="wptravel-blocks-trip-featured">
																	<i class="fas fa-crown"></i> Featured
																</div>
															}
														</div>
													</div>
													<div className="wptravel-blocks-card-body">
														<div className="wptravel-blocks-card-body-top">
															<div className="wptravel-blocks-floating-container">
																<div className="wptravel-blocks-trip-code">
																	<span className="code-hash">#</span> {data.trip_code}
																</div>
															</div>
															<div className="wptravel-blocks-card-body-header">
																<a href="#">
																	<h3 className="wptravel-blocks-card-title">
																		{data.trip_title}
																	</h3>
																</a>
																<div class="favourite">
																	<a href="#" data-id="1375" data-event="add" title="Add to wishlists" class="wp-travel-add-to-wishlists" tabindex="0">
																		<i class="far fa-bookmark"></i> Add to wishlists
																	</a>
																</div>
															</div>
															<div className="wptravel-blocks-card-content">

																<div className="wptravel-blocks-trip-meta">
																	<i className='far fa-calendar-alt'></i> Date
																</div>


																<div className="wptravel-blocks-trip-meta">
																	<i className="fas fa-map-marker-alt"></i>
																	<a href="#">Destination</a>
																</div>


																<div className="wptravel-blocks-trip-meta">
																	<i className="fas fa-users"></i> Group Size
																</div>

															</div>
														</div>
														<div className="wptravel-blocks-card-footer">
															<div className="wptravel-blocks-footer-left">
																<div className="wptravel-blocks-trip-rating">
																	<i className='fa fa-star'></i>
																	<i className='fa fa-star'></i>
																	<i className='fa fa-star'></i>
																	<i className='fa fa-star'></i>
																	<i className='fa fa-star'></i>
																</div>
																<div className="wptravel-blocks-trip-explore">
																	<a href="#">
																		<button className="wp-block-button__link wptravel-blocks-explore-btn">Explore</button>
																	</a>
																</div>
															</div>
															<div className="wptravel-blocks-footer-right">

																<div className="wptravel-blocks-trip-offer">
																	Save 20%
																</div>
																<div className="wptravel-blocks-trip-original-price">
																	<del>$4999</del>
																</div>
																<div className="wptravel-blocks-trip-offer-price">$3999</div>

															</div>
														</div>
													</div>
												</div>
											}
											{
												layoutType === 'layout-one' &&
												<div className="wptravel-blocks-trip-card">
													<div className="same-height wptravel-blocks-trip-card-img-container">
														<img fetchpriority="high" width="1024" height="684" src={data.featured_img} sizes="(max-width: 1024px) 100vw, 1024px"></img>
														<div className="wptravel-blocks-img-overlay">
															{data.is_featured_trip == 'yes' &&
																<div class="wptravel-blocks-trip-featured">
																	<i class="fas fa-crown"></i> Featured
																</div>
															}
														</div>
													</div>
													<div className="wptravel-blocks-card-body">
														<div className="wptravel-blocks-card-body-top">
															<div className="wptravel-blocks-floating-container">
																<div className="wptravel-blocks-trip-code">
																	<span className="code-hash">#</span> {data.trip_code}
																</div>
															</div>
															<div className="wptravel-blocks-card-body-header">
																<a href="#">
																	<h3 className="wptravel-blocks-card-title">
																		{data.trip_title}
																	</h3>
																</a>
																<div class="favourite">
																	<a href="#" data-id="1375" data-event="add" title="Add to wishlists" class="wp-travel-add-to-wishlists" tabindex="0">
																		<i class="far fa-bookmark"></i> Add to wishlists
																	</a>
																</div>
															</div>
															<div className="wptravel-blocks-card-content">

																<div className="wptravel-blocks-trip-meta">
																	<i className='far fa-calendar-alt'></i> Date
																</div>


																<div className="wptravel-blocks-trip-meta">
																	<i className="fas fa-map-marker-alt"></i>
																	<a href="#">Destination</a>
																</div>


																<div className="wptravel-blocks-trip-meta">
																	<i className="fas fa-users"></i> Group Size
																</div>

															</div>
														</div>
														<div className="wptravel-blocks-card-footer">
															<div className="wptravel-blocks-footer-left">
																<div className="wptravel-blocks-trip-rating">
																	<i className='fa fa-star'></i>
																	<i className='fa fa-star'></i>
																	<i className='fa fa-star'></i>
																	<i className='fa fa-star'></i>
																	<i className='fa fa-star'></i>
																</div>
																<div className="wptravel-blocks-trip-explore">
																	<a href="#">
																		<button className="wp-block-button__link wptravel-blocks-explore-btn">Explore</button>
																	</a>
																</div>
															</div>
															<div className="wptravel-blocks-footer-right">

																<div className="wptravel-blocks-trip-offer">
																	Save 20%
																</div>
																<div className="wptravel-blocks-trip-original-price">
																	<del>$4999</del>
																</div>
																<div className="wptravel-blocks-trip-offer-price">$3999</div>

															</div>
														</div>
													</div>
												</div>
											}
											{
												layoutType === 'layout-two' &&
												<div class="wptravel-blocks-trip-card">
													<div class="wptravel-blocks-trip-card-img-container">
														<img fetchpriority="high" width="1024" height="684" src={data.featured_img} sizes="(max-width: 1024px) 100vw, 1024px"></img>
														<div class="wptravel-blocks-img-overlay-base">
															<div class="wptravel-blocks-img-overlay">
																{data.is_featured_trip == 'yes' &&
																	<div class="wptravel-blocks-trip-featured">
																		<i class="fas fa-crown"></i> Featured
																	</div>
																}
																{/* Wishlist goes here */}
															</div>
														</div>
													</div>
													<div class="wptravel-blocks-card-body">
														<div class="wptravel-blocks-card-body-top">
															{/* <div class="wptravel-blocks-floating-container">
																<div class="wptravel-blocks-trip-meta">
																	<i class="fas fa-map-marker-alt"></i>
																	<a href="#">Destination</a>
																</div>
															</div> */}
															<div class="wptravel-blocks-card-body-header">
																<a href="#">
																	<h3 class="wptravel-blocks-card-title">
																		{data.trip_title}
																	</h3>
																</a>
																<div class="wptravel-blocks-trip-rating">
																	<i class="fas fa-star"></i> 4.7
																</div>
															</div>
															<div class="wptravel-blocks-card-content">
																<div class="wptravel-blocks-trip-excerpt">
																	{data.excerpt}
																</div>
															</div>
														</div>
														<div class="wptravel-blocks-card-footer">
															<div class="wptravel-blocks-footer-left">
																<div class="wptravel-blocks-trip-meta">
																	<i class='far fa-clock'></i> Duration
																</div>
																<div class="wptravel-blocks-trip-meta">
																	<i class="fas fa-users"></i> Group Size
																</div>
																<div class="wptravel-blocks-trip-explore">
																	<a href="#">
																		<button class="wp-block-button__link wptravel-blocks-explore-btn">Explore</button>
																	</a>
																</div>
															</div>
															<div class="wptravel-blocks-footer-right">
																<div class="wptravel-blocks-trip-offer">
																	Save 20%
																</div>
																<div class="wptravel-blocks-trip-original-price">
																	<del>$4999</del>
																</div>
																<div class="wptravel-blocks-trip-offer-price">$3999</div>
															</div>
														</div>
													</div>
												</div>
											}
											{
												layoutType === 'layout-three' &&
												<div class="wptravel-blocks-trip-card">
													<div class="wptravel-blocks-trip-card-img-container">
														<img fetchpriority="high" width="1024" height="684" src={data.featured_img} sizes="(max-width: 1024px) 100vw, 1024px"></img>
														<div class="wptravel-blocks-img-overlay-base">
															<div class="wptravel-blocks-img-overlay">
																{data.is_featured_trip == 'yes' &&
																	<div class="wptravel-blocks-trip-featured">
																		<i class="fas fa-crown"></i> Featured
																	</div>
																}
															</div>
															<div class="wptravel-blocks-trip-meta-container">
																<div class="wptravel-blocks-trip-meta">
																	<i class="fas fa-map-marker-alt"></i>
																	<a href="#">Destination</a>
																</div>
																<div class="wptravel-blocks-trip-meta">
																	<i class='far fa-calendar-alt'></i> Date
																</div>
																<div class="wptravel-blocks-trip-meta">
																	<i class="fas fa-users"></i> Group Size
																</div>
															</div>
														</div>
													</div>
													<div class="wptravel-blocks-card-body">
														<div class="wptravel-blocks-card-body-top">
															<div class="wptravel-blocks-card-body-header">
																<a href="#">
																	<h3 class="wptravel-blocks-card-title">
																		{data.trip_title}
																	</h3>
																</a>
																<div class="favourite">
																	<a href="#" data-id="1375" data-event="add" title="Add to wishlists" class="wp-travel-add-to-wishlists" tabindex="0">
																		<i class="far fa-bookmark"></i> Add to wishlists
																	</a>
																</div>
															</div>
															<div class="wptravel-blocks-card-content">
																<div class="wptravel-blocks-trip-excerpt">
																	{data.trip_excerpt}
																</div>
															</div>
														</div>
														<div class="wptravel-blocks-card-footer">
															<div class="wptravel-blocks-footer-left">
																<div class="wptravel-blocks-trip-rating">
																	<i className='fa fa-star'></i>
																	<i className='fa fa-star'></i>
																	<i className='fa fa-star'></i>
																	<i className='fa fa-star'></i>
																	<i className='fa fa-star'></i>
																</div>
																<div class="wptravel-blocks-trip-explore">
																	<a href="#">
																		<button class="wp-block-button__link wptravel-blocks-explore-btn">Explore</button>
																	</a>
																</div>
															</div>
															<div class="wptravel-blocks-footer-right">
																<div class="wptravel-blocks-trip-offer">
																	Save 20%
																</div>
																<div class="wptravel-blocks-trip-original-price">
																	<del>$4999</del>
																</div>
																<div class="wptravel-blocks-trip-offer-price">$3999</div>
															</div>
														</div>
													</div>
												</div>
											}
											{
												layoutType === 'layout-four' &&
												<div class="wptravel-blocks-trip-card">
													<div class="wptravel-blocks-trip-card-img-container">
														<img fetchpriority="high" width="1024" height="684" src={data.featured_img} sizes="(max-width: 1024px) 100vw, 1024px"></img>
														<div class="wptravel-blocks-img-overlay-base">
															<div class="wptravel-blocks-img-overlay">
																<div class="wptravel-blocks-trip-offer">
																	Save 20%
																</div>
																{data.is_featured_trip == 'yes' &&
																	<div class="wptravel-blocks-trip-featured">
																		<i class="fas fa-crown"></i>
																	</div>
																}
															</div>
														</div>
													</div>
													<div class="wptravel-blocks-card-body">
														<div class="wptravel-blocks-card-body-top">
															<div class="wptravel-blocks-card-body-header">
																<div class="wptravel-blocks-header-left">
																	<a href="#">
																		<h3 class="wptravel-blocks-card-title">
																			{data.trip_title}
																		</h3>
																	</a>
																	<div class="wptravel-blocks-trip-code">
																		<span class="code-hash">#</span> {data.trip_code}
																	</div>
																</div>
																<div class="favourite">
																	<a href="#" data-id="1375" data-event="add" title="Add to wishlists" class="wp-travel-add-to-wishlists" tabindex="0">
																		<i class="far fa-bookmark"></i> Add to wishlists
																	</a>
																</div>
															</div>
															<div class="wptravel-blocks-card-content">
																<div class="wptravel-blocks-trip-excerpt">
																	{data.trip_excerpt}
																</div>
																<div class="wptravel-blocks-trip-meta-container">
																	<div class="wptravel-blocks-trip-meta">
																		<i class='far fa-clock'></i> Duration
																	</div>
																	<div class="wptravel-blocks-trip-meta">
																		<i class="fas fa-map-marker-alt"></i>
																		<a href="#">Destination</a>
																	</div>
																	<div class="wptravel-blocks-trip-meta">
																		<i class="fas fa-users"></i> Group Size
																	</div>
																</div>
															</div>
														</div>
														<div class="wptravel-blocks-card-footer">
															<div class="wptravel-blocks-footer-left">
																<div class="wptravel-blocks-trip-rating">
																	<i className='fa fa-star'></i>
																	<i className='fa fa-star'></i>
																	<i className='fa fa-star'></i>
																	<i className='fa fa-star'></i>
																	<i className='fa fa-star'></i>
																</div>
															</div>
															<div class="wptravel-blocks-footer-right">
																<div class="wptravel-blocks-trip-original-price">
																	<del>$4999</del>
																</div>
																<div class="wptravel-blocks-trip-offer-price">$3999</div>
															</div>
														</div>
													</div>
												</div>
											}
										</>
									);
								})
							}

						</Slider>
					</div>
				</div>
				||
				<ServerSideRender
					block="wp-travel-blocks/trips-list"
					attributes={props.attributes}
				/>
			}

		</div>
	);
}
